import _ from 'lodash';
import splitViewManager from '../utilities/splitViewManager';
import { BUILDEE_SERVICES } from './constants';
import { isTrackerPath } from './trackerUtil';
import SessionStorageService from '../services/utilities/SessionStorageService';

/**
 * urlのパラメータ管理
 */
class urlParamManager {
  constructor() {
    this.singlePages = ['FieldTree'];

    this.delegate = [];
    this.pagedelegate = [];
    this.pageWillLoadCallback = [];
    this.urlparam = [0, 0];
    this.masterparam = 0;
    this.slide = [0, 0];
    this.split = [];

    this.getParam(); //urlを設定

    //マウントしたらすぐにパブリッシュする
    setTimeout(() => {
      this.publish();
    }, 100);

    //戻るに対応
    window.addEventListener('popstate', () => {
      setTimeout(() => {
        this.publish();
      }, 100);
    });

    //TODO マスターの変更をデリゲート

    //開閉状態をデリゲート
    // eslint-disable-next-line no-unused-vars
    splitViewManager.setDelegate((split, conference) => {
      //split[true,true] => [ 左view , 右view ]
      //this.urlparam => this.urlparam[0] => 右view , this.urlparam[1] ＝＞左view

      //TODO
      //this.urlparam[0]|this.urlparam[1]==0の場合、
      //もう一方と同じページを入れて開く
      // if ( this.urlparam[1] == 0 ) {
      //   this.urlparam[1] = this.urlparam[0];
      // }
      // if ( this.urlparam[0] == 0 ) {
      //   this.urlparam[0] = this.urlparam[1];
      // }

      //右
      let _rightviewparam = this.urlparam[0].split(':');
      this.urlparam[0] = split[0] ? `${_rightviewparam[0]}:1` : 0;
      //this.urlparam[0] = `${_rightviewparam[0]}:${split[0]==true?1:0}`;

      //左
      let _leftviewparam = this.urlparam[1].split(':');
      this.urlparam[1] = split[1] ? `${_leftviewparam[0]}:1` : 0;
      // this.urlparam[1] = `${_leftviewparam[0]}:${split[1]==true?1:0}`;

      if (window.history && window.history.pushState) {
        if (isTrackerPath()) {
          window.location.replace(this.getUrl());
        } else {
          window.history.pushState(null, null, this.getUrl());
        }
        this.publish();
      }
    });
  }

  /**
   * 初期ロード
   * @param {function} func
   */
  setDelegate(func) {
    this.delegate.push(func);
  }

  /**
   * ページのロード
   * @param {function} func
   */
  pageWillLoad(func) {
    this.pageWillLoadCallback.push(func);
  }

  removePageWillLoad(func) {
    this.pageWillLoadCallback = _.filter(
      this.pageWillLoadCallback,
      f => f !== func
    );
  }

  /**
   * デリゲート
   */
  publish() {
    this.getParam();
    _.each(this.delegate, func => {
      if (func) {
        func(this.urlparam, this.masterparam, this.slide);
      }
    });
  }

  /**
   * urlを変更する
   * @param { string } page
   * @param { int } view
   */
  setPage(page, view) {
    const _page = page.match(/.*(:)(\d+)$/);
    this.urlparam[view - 1] = _page ? page : `${page}:1`;

    if (window.history && window.history.pushState) {
      if (isTrackerPath()) {
        window.location.replace(this.getUrl());
      } else {
        window.history.pushState(null, null, this.getUrl());
      }
    }

    _.each(this.pageWillLoadCallback, func => {
      if (func) {
        func(this.urlparam, this.masterparam, this.slide);
      }
    });
  }

  setMaster(master, props) {
    if (!master) {
      //閉じる
      this.masterparam = '0';
    } else {
      //開く
      this.masterparam = `${master}:${props.state.id || 0}`;
    }

    if (window.history && window.history.pushState) {
      if (isTrackerPath()) {
        SessionStorageService.setItem('url_tracker', window.location.href);
        window.location.href = this.getUrl();
      } else {
        window.history.pushState(null, null, this.getUrl());
      }
    }

    this.getParam();
    _.each(this.pageWillLoadCallback, func => {
      if (func) {
        func(this.urlparam, this.masterparam, this.slide);
      }
    });
  }

  /**
   * ページを指定
   * @param {string} page
   * @param {int} view
   * @param {int} number
   */
  setPageNumber(page, view, number, noUseHistory = false) {
    this.urlparam[view - 1] = `${page}:${number}`;
    if (!noUseHistory) {
      if (window.history && window.history.pushState) {
        if (isTrackerPath()) {
          window.location.replace(this.getUrl());
        } else {
          window.history.pushState(null, null, this.getUrl());
        }
      }
    }
    // console.log('debug', 'setPageNumber', this.pagedelegate.length);
    if (this.pagedelegate.length) {
      _.each(this.pagedelegate, val => {
        if (Object.keys(val)[0] === page) {
          val[page](page, view, number);
        }
      });
    }
  }

  /**
   * ページの番号変更を通知
   */
  setPageNumberDelegate(pageName, func) {
    let page = _.filter(this.pagedelegate, val => {
      return Object.keys(val)[0] == pageName;
    });
    if (!page.length) {
      let f = {};
      f[pageName] = func;
      this.pagedelegate.push(f);
    }
  }

  removePageNumberDelegate(pageName) {
    this.pagedelegate = _.remove(this.pagedelegate, (val, key) => {
      return key == pageName;
    });
  }

  /**
   * スライドURL変更する
   * @param { string } slide
   * @param { int } vw
   * @param { bool } show
   */
  setSlide(slide, props, vw) {
    if (!slide) {
      //閉じる
      this.slide[vw - 1] = '0';
    } else {
      //開く
      this.slide[vw - 1] = `${slide}:${props.state.id ? props.state.id : 0}`;
    }
    if (window.history && window.history.pushState) {
      //console.log("push state",vw , this.slide , this.getUrl());
      if (isTrackerPath()) {
        window.location.replace(this.getUrl());
      } else {
        window.history.pushState(null, null, this.getUrl());
      }
    }

    _.each(this.pageWillLoadCallback, func => {
      if (func) {
        func(this.urlparam, this.masterparam, this.slide);
      }
    });
  }

  /**
   * splitパラメータ
   */
  getParam() {
    const url = window.location.href.split('/');
    if (url.length >= 8) {
      this.masterparam = url[url.length - 5] || 0;
      this.urlparam[0] = url[url.length - 2] || 0;
      this.urlparam[1] = url[url.length - 1] || 0;
      this.slide[0] = url[url.length - 4] || 0;
      this.slide[1] = url[url.length - 3] || 0;
    }
  }

  /**
   * urlを作成
   */
  getUrl() {
    if (isTrackerPath()) {
      const url = [
        window.location.origin,
        'conference',
        this.masterparam,
        this.slide[0],
        this.slide[1],
        this.urlparam[0],
        this.urlparam[1],
      ];
      return url.join('/');
    }
    const url = window.location.href.split('/');
    url[url.length - 5] = this.masterparam;
    url[url.length - 1] = this.urlparam[1];
    url[url.length - 2] = this.urlparam[0];
    url[url.length - 3] = this.slide[1];
    url[url.length - 4] = this.slide[0];
    return url.join('/');
  }

  getSlideParam() {
    return this.slide;
  }

  /**
   * conference部分をかえす
   */
  getCategoryType() {
    const url = window.location.href.split('/');
    return url[url.length - 6];
  }

  /**
   * URLから選択しているBuildeeサービスのIDを返却する
   * 合致するものがなければ調整会議のサービスIDを返却する
   * @return {number}
   * */
  getCurrentServiceTypeId = () => {
    if (isTrackerPath()) {
      return BUILDEE_SERVICES.TRACKER.ID;
    }
    const categoryType = this.getCategoryType();
    const currentService = _.find(BUILDEE_SERVICES, service => {
      return service.KEYWORD === categoryType;
    });
    if (_.isNil(currentService)) {
      if (isTrackerPath()) {
        return BUILDEE_SERVICES.TRACKER.ID;
      }
      return BUILDEE_SERVICES.CONFERENCE.ID;
    }

    return currentService.ID;
  };

  /**
   * URLの中から渡されたパラメータを削除して書き換える
   * @param {string} paramName 削除するパラメータ名 
   * */
  removeUrlParam = (paramName) => {
    let url = new URL(window.location.href);
    url.searchParams.delete(paramName); // パラメータをURLから除く
    history.replaceState(null, '', url.href); // URLを書き換える
  }
}
const _urlParamManager = new urlParamManager();
export default _urlParamManager;



// WEBPACK FOOTER //
// ./src/utilities/urlParamManager.js